// extracted by mini-css-extract-plugin
export default {"container":"AffiliatePerformances_container__lYGPS"};